import { gql } from '@apollo/client/core'

import { ATTRIBUTE_FRAGMENT } from './attribute'

export const COURSE_FRAGMENT = gql`
  ${ATTRIBUTE_FRAGMENT}
  fragment Course on Course {
    id
    courseName
    slug
    createdAt
    description
    priceRange
    attributes {
      ...Attribute
    }
    map
    gallery
    galleryPaths
    courseRating
    par
    numHoles
    open
    club {
      ... on GetClubOutput {
        club {
          id
          clubName
          slug
          city
          logo
          addressLine1
          addressLine2
          city
          province
          postalCode
          country
          phoneNumber
          averageRating
          amenities {
            icon
            name
            id
          }
          addressGeom {
            lat
            lon
          }
          isNonGolf
        }
      }
    }
  }
`
